import Phaser from 'phaser';

export class SceneLoadBase extends Phaser.Scene {
  constructor(opts) {
    super(opts);
    this.debug = opts.debug || false;
  }

  init() {
    this.handleLoadStart = this.loadStart.bind(this);
    this.handleLoadProgress = this.loadProgress.bind(this);
    this.handleFileLoadProgress = this.loadFileProgress.bind(this);
    this.handleFileLoadComplete = this.loadFileComplete.bind(this);
    this.handleLoadError = this.loadError.bind(this);
    this.handleLoadAssetPackComplete = this.loadAssetPackComplete.bind(this);
    this.handleLoadComplete = this.loadComplete.bind(this);
    this.errorCount = 0;
    this.loadHasErrored = false;
  }

  renderScene() {}

  preload(path) {
    this.renderScene();

    this.load.crossOrigin = 'anonymous';
    this.load.path = path;
    this.load.on('start', this.handleLoadStart);
    this.load.on('progress', this.handleLoadProgress);
    this.load.on('fileprogress', this.handleFileLoadProgress);
    this.load.on('filecomplete', this.handleFileLoadComplete);
    this.load.on('loaderror', this.handleLoadError);
    this.load.on('complete', this.handleLoadAssetPackComplete);
  }

  loadStart() {
    this.debug && console.log('Load.handleLoadStart');
  }

  loadProgress(value) {
    this.debug && console.log('Load.loadProgress', value);
  }

  loadFileProgress(file) {
    this.debug && console.log('Load.loadFileProgress | type ' + file.type + ' | key ' + file.key);
  }

  loadFileComplete(key, type) {
    this.debug && console.log('Load.loadFileComplete | type ' + type + ' | key ' + key);
  }

  loadError(pack) {
    this.loadHasErrored = true;
    this.errorCount++;
    if (pack) {
      let errorMessage = `SceneLoad.loadError | type ${pack.type} | key ${pack.key} | src ${pack.src}`;
      errorMessage +=
        '\n-- status : ' +
        pack.xhrLoader.status +
        ' | -- statusText : ' +
        pack.xhrLoader.statusText;
      console.error(errorMessage + ' | -- response :\n' + pack.xhrLoader.response);
      this.add.text(30, this.errorCount * 60, errorMessage, {
        fontFamily: 'Arial',
        color: '#00ff00',
        fontSize: '21px',
      });
    }
  }

  loadAssetPackComplete() {
    this.debug && console.log('Load.loadAssetPackComplete');
  }

  create() {
    this.load.off('complete', this.handleLoadAssetPackComplete);
    this.load.on('complete', this.handleLoadComplete);
    this.load.start();
  }

  loadComplete() {
    this.load.off('progress', this.handleLoadProgress);
    this.load.off('fileprogress', this.handleFileLoadProgress);
    this.load.off('filecomplete', this.handleFileLoadComplete);
    this.load.off('loaderror', this.handleLoadError);
    this.load.off('complete', this.handleLoadComplete);

    this.start();
  }

  start() {} // override

  shutdown() {}
}
